export default "/images/tutorial_b.webp"